import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import PokeMovieSite from './App';
import PlayPage from './PlayPage';
import WikiPage from './WikiPage';
import BlogPage from './BlogPage';
import ArticlePage from './ArticlePage';
import RulesPage from './RulesPage';
import Features from './Features';
import Community from './Community';

// Wrapper component to add navigation to buttons
const HomePage = () => {
    const navigate = useNavigate();

    // Clone the PokeMovieSite component and add navigation handlers
    return (
        <div onClick={(e) => {
            // Check if a clicked element or parent has the class for play buttons
            const target = e.target.closest('button, a');
            if (target) {
                if (target.textContent.includes('JOUER') ||
                    target.textContent.includes('COMMENCER L\'AVENTURE') ||
                    target.textContent.includes('Jouer Maintenant')) {
                    e.preventDefault();
                    navigate('/play');
                }
                // Handle Wiki link
                if (target.textContent.includes('Wiki') && target.tagName === 'A') {
                    e.preventDefault();
                    navigate('/wiki');
                }
                // Handle Blog link
                if (target.textContent.includes('Blog') && target.tagName === 'A') {
                    e.preventDefault();
                    navigate('/blog');
                }
                // Handle Rules link
                if (target.textContent.includes('Règlement') && target.tagName === 'A') {
                    e.preventDefault();
                    navigate('/rules');
                }
                // Handle Features link
                if (target.textContent.includes('Fonctionnalités') && target.tagName === 'A') {
                    e.preventDefault();
                    navigate('/fonctionnalites');
                }
                // Handle Community link
                if (target.textContent.includes('Communauté') && target.tagName === 'A') {
                    e.preventDefault();
                    navigate('/communaute');
                }
            }
        }}>
            <PokeMovieSite />
        </div>
    );
};

// Main App with routing
const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/play" element={<PlayPage />} />
                <Route path="/wiki" element={<WikiPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<ArticlePage />} />
                <Route path="/rules" element={<RulesPage />} />
                <Route path="/fonctionnalites" element={<Features />} />
                <Route path="/communaute" element={<Community />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter;